import Modal from '@components/v2/ui/Modal/Modal';
import LangEnum from '../../../../../../lang/LangEnum';
import { ClarityEvents } from '../../../../../../lib/clarity/types/clarityEvents.types';
import { withEvent } from '../../../../../../lib/clarity/utils/captureEvent.utils';
import { useTranslation } from '../../../../../translation/TranslationContext';

interface OfflineConfirmDeleteProductsModalProps {
  isOpen: boolean;
  onClose: () => void;
  removeOfflineData: () => void;
}

const OfflineConfirmDeleteProductsModal = ({
  isOpen,
  onClose,
  removeOfflineData,
}: OfflineConfirmDeleteProductsModalProps) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="standard"
      header={{ title: translate(LangEnum.OFFLINE_REMOVE_DOWNLOADED_DATA) }}
      onClose={onClose}
      footer={{
        primaryAction: {
          onClick: withEvent(ClarityEvents.DELETE_OFFLINE_DATA, removeOfflineData),
          label: translate(LangEnum.GLOBAL_DELETE),
        },
        secondaryAction: {
          onClick: onClose,
          label: translate(LangEnum.GLOBAL_CANCEL_LABEL),
        },
      }}
    />
  );
};

export default OfflineConfirmDeleteProductsModal;
